import React from "react";
import { calloutColor, CalloutStates } from "../new-editor/elements/Callout";
import { Box, BoxProps, Button, Theme, Typography } from "@mui/material";
import { LucideProps } from "lucide-react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

interface StylesProps {
  mainColor: string;
  backgroundColor: string;
}

export const calloutSettingsStyles = makeStyles<Theme, StylesProps>(
  (theme) => ({
    labelTip: {
      fontSize: 13,
      lineHeight: 1.2,
      padding: theme.spacing(0, 1),
    },
    container: {
      display: "flex",
      gap: theme.spacing(1.5),
      borderLeft: `${theme.spacing(0.8)} solid`,
      justifyContent: "space-between",
      borderColor: (props: StylesProps) => props.mainColor,
      borderRadius: theme.spacing(0.8),
      background: (props: StylesProps) => props.backgroundColor,
      padding: theme.spacing(1),
    },
  }),
);

interface CalloutContainerProps extends BoxProps {
  onClick?: () => void;
  text: React.ReactNode;
  calloutButton: {
    icon: React.ForwardRefExoticComponent<
      Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>
    >;
    text: string;
  };
  calloutState: CalloutStates;
}

const CalloutContainer = ({
  onClick,
  text,
  className,
  calloutState = CalloutStates.SUCCESS,
  calloutButton,
}: CalloutContainerProps) => {
  const mainColor = calloutColor[calloutState].main;
  const backgroundColor = calloutColor[calloutState].background;
  const s = calloutSettingsStyles({
    mainColor,
    backgroundColor,
  });

  return (
    <Box className={clsx(s.container, className)}>
      <Box display={"flex"} alignItems={"center"}>
        <Typography className={s.labelTip}>{text}</Typography>
      </Box>
      <Box>
        <Button
          sx={{ color: mainColor, padding: 1 }}
          startIcon={React.createElement(calloutButton.icon, {
            color: mainColor,
          })}
          onClick={onClick}
        >
          {calloutButton.text}
        </Button>
      </Box>
    </Box>
  );
};

export default CalloutContainer;
